import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Card, CardBody, CardFooter, CardTitle, CardHeader, Badge, Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Loader from "./Loader/Loader";
import swal from 'sweetalert';
import { betSlipService } from './../redux/betslip/services';
import { userService } from './../redux/auth/services';

const Betslip = () => {
    const dispatch = useDispatch();
    const { betSlips, parlayBetSlips, isLoading, user } = useSelector(state => ({
        betSlips: state.BetSlip.betSlips,
        parlayBetSlips: state.BetSlip.parlayBetSlips,
        isLoading: state.BetSlip.isLoading,
        user: state.Auth.user,
    }));
    const [activeTab, setActiveTab] = useState('1');
    const [betSlipCount, setBetSlipCount] = useState(Object.keys(betSlips).length);
    const [isBetUpdated, setIsBetUpdated] = useState(false);

    useEffect(() => {
        setBetSlipCount(Object.keys(betSlips).length);
    }, [betSlips]);

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            setBetSlipCount(prevCount => (prevCount !== 3 ? 3 : 4));
        }
    };

    const removeFromBetSlip = (odd) => {
        dispatch({ type: "REMOVE_FROM_BETSLIP", payload: odd });
    };

    const updateParlayStackValue = (event, bet) => {
        let stackVal = parseFloat(event.target.value) || 0;
        dispatch({ type: 'LOAD_BETSLIP' });
        let totalParlayWinAmount = 1;

        Object.keys(bet).forEach(item => {
            let winValue;
            if (bet[item].value > 0) {
                winValue = 1 + (bet[item].value / 100);
            } else {
                winValue = 1 - (100 / bet[item].value);
            }
            bet[item].win_value = winValue.toFixed(2);
            bet[item].stake_value = stackVal.toFixed(2);
            totalParlayWinAmount *= parseFloat(bet[item].win_value);
            setIsBetUpdated(true);
            dispatch({ type: "UPDATE_TO_PARLAY_BETSLIP", payload: bet[item] });
        });
    };

    const updateStackValue = (event, key, bet) => {
        let stackVal = parseFloat(event.target.value) || 0;
        dispatch({ type: 'LOAD_BETSLIP' });
        bet.stake_value = stackVal;
        let winValue;
        if (bet.value > 0) {
            winValue = stackVal * (1 + (bet.value / 100));
        } else {
            winValue = stackVal * (1 - (100 / bet.value));
        }
        bet.win_value = winValue.toFixed(2);
        setIsBetUpdated(true);
        dispatch({ type: "UPDATE_TO_BETSLIP", payload: bet });
    };

    const roundOfStackValue = (event, key, bet) => {
        let stackVal = parseFloat(event.target.value) || 0;
        dispatch({ type: 'LOAD_BETSLIP' });
        bet.stake_value = stackVal.toFixed(2);
        let winValue;
        if (bet.value > 0) {
            winValue = stackVal * (1 + (bet.value / 100));
        } else {
            winValue = stackVal * (1 - (100 / bet.value));
        }
        bet.win_value = winValue.toFixed(2);
        setIsBetUpdated(true);
        dispatch({ type: "UPDATE_TO_BETSLIP", payload: bet });
    };

    const updateWinValue = (event, key, bet) => {
        let winVal = parseFloat(event.target.value) || 0;
        dispatch({ type: 'LOAD_BETSLIP' });
        bet.win_value = winVal;
        bet.stake_value = (winVal / bet.value).toFixed(2);
        setIsBetUpdated(true);
        dispatch({ type: "UPDATE_TO_BETSLIP", payload: bet });
    };

    const roundOfWinValue = (event, key, bet) => {
        let winVal = parseFloat(event.target.value) || 0;
        dispatch({ type: 'LOAD_BETSLIP' });
        bet.win_value = winVal.toFixed(2);
        bet.stake_value = (winVal / bet.value).toFixed(2);
        setIsBetUpdated(true);
        dispatch({ type: "UPDATE_TO_BETSLIP", payload: bet });
    };

    const clearAllBetSlips = () => {
        dispatch({ type: 'CLEAR_BETSLIP' });
    };

    const createBetSlip = () => {
        if (!user) {
            swal("Please login first to place your bet.", { icon: "error" });
            return;
        }
        dispatch({ type: 'LOAD_BETSLIP' });
        betSlipService.placeBet(betSlips).then(response => {
            if (response.response_code === 200) {
                refreshUserSummary();
                swal(response.message, { icon: "success" });
                dispatch({ type: 'CLEAR_BETSLIP' });
            } else {
                swal(response.message, { icon: "error" });
            }
        }).catch(error => {
            console.log(error);
            dispatch({ type: 'HIDE_BETSLIP_LOADER' });
        });
    };

    const createParlayBetSlip = () => {
        if (!user) {
            swal("Please login first to place your bet.", { icon: "error" });
            return;
        }
        dispatch({ type: 'LOAD_BETSLIP' });
        betSlipService.placeParlayBet(parlayBetSlips).then(response => {
            if (response.response_code === 200) {
                refreshUserSummary();
                swal(response.message, { icon: "success" });
                dispatch({ type: 'CLEAR_BETSLIP' });
            } else {
                swal(response.message, { icon: "error" });
            }
        }).catch(error => {
            console.log(error);
            dispatch({ type: 'HIDE_BETSLIP_LOADER' });
        });
    };

    const refreshUserSummary = () => {
        userService.refreshProfileSummary().then(user => {
            dispatch({ type: 'REFRESH_USER_PROFILE_SUMMARY', payload: user.data });
        });
    };

    let noDataMessage, loading;
    let totalStakeAmount = 0.0, totalWinAmount = 0.0;
    let totalStakeAmount_1 = 0.0, totalWinAmount_1 = 0.0;
    let total_sum_parlay = 1;
    let showPlaceBetButton = false;

    if (isLoading) {
        loading = <Loader />;
    }
    if (betSlipCount === 0 && !isLoading) {
        noDataMessage = (<Alert color="dark" className='text-center'>No Data found.</Alert>);
    }

    return (
        <div className="tab_betslip">
            <Nav tabs>
                <NavItem>
                    <NavLink className={activeTab === "1" ? "active" : ""} onClick={() => toggle("1")}>
                        Single - Bet
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab === "2" ? "active" : ""} onClick={() => toggle("2")}>
                        Multi - Bet
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Card className='betslip-container'>
                        <h5 className="card-header">BET SLIP
                            {(betSlipCount === 0 && !isLoading) ? '' :
                                <button className="btn btn-sm btn-danger float-right pt-0 pb-0" onClick={clearAllBetSlips}>Clear All</button>
                            }
                        </h5>
                        <CardBody className="text-dark p-1">
                            {loading}
                            {noDataMessage}
                            {Object.keys(betSlips).map((item, index) => {
                                const bet = betSlips[item];
                                let stakeVal = bet.stake_value || 0;
                                let win_value = bet.win_value || 0;
                                totalStakeAmount += parseFloat(stakeVal);
                                totalWinAmount += parseFloat(win_value);
                                showPlaceBetButton = true;
                                return (
                                    <Card key={`bet-card-${index}`} className="p-0 card-inverse text-white">
                                        <CardHeader className="p-1 bg-secondary border-0">
                                            <CardTitle>
                                                <b className='d-inline-block'>
                                                    {bet.match_name}
                                                </b>
                                                <button onClick={() => removeFromBetSlip(bet)}
                                                    className="btn btn-link d-inline-block pt-0 pb-0 float-right">X
                                                </button>
                                            </CardTitle>
                                            <div className='text-sm-left'>
                                                {bet.odd_type_name} - {bet.league_name}
                                            </div>
                                            <div>
                                                <span className='d-inline-block'>
                                                    Odds:
                                                </span>
                                                <Badge color="danger" className='ml-1'>{bet.value}</Badge>
                                            </div>
                                        </CardHeader>
                                        <CardBody className='p-2 bg-light text-dark'>
                                            <div className='form-group mb-2'>
                                                <label className='d-block'>Stake:</label>
                                                <input type='number' className='form-control'
                                                    value={stakeVal}
                                                    onChange={(e) => updateStackValue(e, item, bet)}
                                                    onBlur={(e) => roundOfStackValue(e, item, bet)}
                                                />
                                            </div>
                                            <div className='form-group mb-2'>
                                                <label className='d-block'>Win Amount:</label>
                                                <input type='number' className='form-control'
                                                    value={win_value}
                                                    onChange={(e) => updateWinValue(e, item, bet)}
                                                    onBlur={(e) => roundOfWinValue(e, item, bet)}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                );
                            })}
                        </CardBody>
                        <CardFooter className="p-2 text-white bg-dark">
                            <div className='d-inline-block'>
                                <span>Total Stake Amount: </span>
                                <span className='font-weight-bold'>{totalStakeAmount.toFixed(2)}</span>
                            </div>
                            <div className='d-inline-block float-right'>
                                <span>Total Win Amount: </span>
                                <span className='font-weight-bold'>{totalWinAmount.toFixed(2)}</span>
                            </div>
                        </CardFooter>
                        {showPlaceBetButton && (
                            <CardFooter className="p-2 text-center">
                                <Button color='danger' className='btn-block' onClick={createBetSlip}>Place Bet</Button>
                            </CardFooter>
                        )}
                    </Card>
                </TabPane>
                <TabPane tabId="2">
                    <Card className='betslip-container'>
                        <h5 className="card-header">PARLAY BET SLIP
                            {(betSlipCount === 0 && !isLoading) ? '' :
                                <button className="btn btn-sm btn-danger float-right pt-0 pb-0" onClick={clearAllBetSlips}>Clear All</button>
                            }
                        </h5>
                        <CardBody className="text-dark p-1">
                            {loading}
                            {noDataMessage}
                            {Object.keys(parlayBetSlips).map((item, index) => {
                                const bet = parlayBetSlips[item];
                                let stakeVal = bet.stake_value || 0;
                                let win_value = bet.win_value || 0;
                                totalStakeAmount_1 += parseFloat(stakeVal);
                                total_sum_parlay *= parseFloat(win_value);
                                showPlaceBetButton = true;
                                return (
                                    <Card key={`parlay-card-${index}`} className="p-0 card-inverse text-white">
                                        <CardHeader className="p-1 bg-secondary border-0">
                                            <CardTitle>
                                                <b className='d-inline-block'>
                                                    {bet.match_name}
                                                </b>
                                                <button onClick={() => removeFromBetSlip(bet)}
                                                    className="btn btn-link d-inline-block pt-0 pb-0 float-right">X
                                                </button>
                                            </CardTitle>
                                            <div className='text-sm-left'>
                                                {bet.odd_type_name} - {bet.league_name}
                                            </div>
                                            <div>
                                                <span className='d-inline-block'>
                                                    Odds:
                                                </span>
                                                <Badge color="danger" className='ml-1'>{bet.value}</Badge>
                                            </div>
                                        </CardHeader>
                                        <CardBody className='p-2 bg-light text-dark'>
                                            <div className='form-group mb-2'>
                                                <label className='d-block'>Stake:</label>
                                                <input type='number' className='form-control'
                                                    value={stakeVal}
                                                    onChange={(e) => updateParlayStackValue(e, bet)}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                );
                            })}
                        </CardBody>
                        <CardFooter className="p-2 text-white bg-dark">
                            <div className='d-inline-block'>
                                <span>Total Stake Amount: </span>
                                <span className='font-weight-bold'>{totalStakeAmount_1.toFixed(2)}</span>
                            </div>
                            <div className='d-inline-block float-right'>
                                <span>Total Win Amount: </span>
                                <span className='font-weight-bold'>{total_sum_parlay.toFixed(2)}</span>
                            </div>
                        </CardFooter>
                        {showPlaceBetButton && (
                            <CardFooter className="p-2 text-center">
                                <Button color='danger' className='btn-block' onClick={createParlayBetSlip}>Place Bet</Button>
                            </CardFooter>
                        )}
                    </Card>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default Betslip;
